import GeneralDialog from '../../../shared/general-dialog';
import { useQuery } from '@tanstack/react-query';
import { getRunLogActions, RulesKeys } from '../../../api/rules-engine-api';
import RulesEngineActionLogsGrid from './rules-engine-action-logs-grid';
import { Policy, RuleModel } from '../../../../types';
import dayjs from 'dayjs';
import Box from '@mui/material/Box';

interface RulesEngineAllActionLogsDialogProps {
  open: boolean;
  handleClose: () => void;
  runLogId: number;
  policies: Policy[];
  rules: RuleModel[];
}

export default function RulesEngineActionLogsDialog({
  open,
  handleClose,
  runLogId,
  policies,
  rules,
}: RulesEngineAllActionLogsDialogProps) {
  const last30Days = dayjs().subtract(30, 'day').startOf('day').valueOf();

  const { isLoading, data, isFetching } = useQuery({
    queryKey: [RulesKeys.RunLogActions, runLogId, last30Days],
    queryFn: () => getRunLogActions(runLogId, last30Days),
    meta: {
      errorMessage:
        'There was an issue loading logs data. Please refresh and try again.',
    },
  });

  return (
    <GeneralDialog
      maxWidth="lg"
      open={open}
      handleClose={handleClose}
      title={`Action Logs: ${runLogId}`}
      dialogContent={
        <Box sx={{ px: 2 }}>
          <RulesEngineActionLogsGrid
            data={data || []}
            isLoading={isLoading || isFetching}
            policies={policies}
            rules={rules}
          />
        </Box>
      }
    />
  );
}
